import React from "react";
import SectionHeader from "../../components/SectionHeader";
import HeaderImage from "../../images/main-banner.png";
import HeaderImage2 from "../../images/banner-side -image.png";
import { Container } from "react-bootstrap";
const PrivacyPolicy = () => {
  return (
    <>
      <SectionHeader
        title="Terms & Condition"
        image={HeaderImage}
        image2={HeaderImage2}
        title2="Terms and Conditions"
        content="Welcome to BOLT-CORP! By accessing or using our website and
              services, you agree to comply with and be bound by the following
              Terms and Conditions. Please read them carefully."
      ></SectionHeader>
      <div className="privacy__policy">
        <Container>
          <div className="pt-5 pb-4">
            <p>
              <strong>Acceptance of Terms: </strong>
              Using the BOLT-CORP website, you agree to these Terms and
              Conditions. If you do not agree with any part of these terms,
              please do not use our website.
            </p>
            <p>
              <strong>Use of Website: </strong>
              You may access and use the BOLT-CORP website for lawful purposes
              only. You agree not to engage in activities that could harm,
              disrupt, or interfere with the website's functionality or other
              users' experience.
            </p>
            <p>
              <strong>Account Registration: </strong>
              To make purchases or use certain services, you may be required to
              register for an account. You agree to provide accurate, current,
              and complete information and to keep your account information
              secure. You are responsible for all activities under your account.
            </p>
            <p>
              <strong>Products and Services: </strong>
              We strive to accurately represent our products and services on our
              website. However, BOLT-CORP does not guarantee product
              availability, quality, or pricing and reserves the right to modify
              or discontinue offerings without prior notice.
            </p>
            <p>
              <strong>Payment and Orders: </strong>
              By placing an order on our website, you agree to pay the full
              price for the products or services ordered. Payments must be made
              through the available methods on our site. BOLT-CORP reserves the
              right to cancel or refuse any order at its discretion.
            </p>
            <p>
              <strong>Intellectual Property: </strong>
              All content on this website, including text, images, logos, and
              product designs, is owned by BOLT-CORP or used under license. You
              may not copy, reproduce, distribute, or use any content from this
              website without explicit permission from BOLT-CORP.
            </p>
            <p>
              <strong>Privacy: </strong>
              Our Privacy Policy governs the collection, use, and protection of
              your personal information. By using the website, you agree to the
              collection and use of your data as outlined in the Privacy Policy.
            </p>
            <p>
              <strong>Limitation of Liability: </strong>
              BOLT-CORP will not be liable for any direct, indirect, incidental,
              special, or consequential damages arising from the use or
              inability to use our website, products, or services.
            </p>
            <p>
              <strong>Governing Law: </strong>
              These Terms and Conditions are governed by the laws of [Your
              Jurisdiction]. Any disputes arising from these terms will be
              resolved in the courts located within that jurisdiction.
            </p>
            <p>
              <strong>Changes to Terms and Conditions: </strong>
              BOLT-CORP reserves the right to modify or update these Terms and
              Conditions at any time. Any changes will be posted on this page,
              and the updated date will be noted at the top.
            </p>
            <p>
              <strong>Termination: </strong>
              BOLT-CORP reserves the right to suspend or terminate your access
              to the website at any time without notice for any violation of
              these Terms and Conditions.
            </p>
            <p>
              <strong>Contact Information: </strong>
              For any questions or concerns regarding these Terms and
              Conditions, please get in touch with us at [contact information].
            </p>
            <p>
              Using the BOLT-CORP website, you acknowledge that you have read
              and agree to these Terms and Conditions.
            </p>
          </div>
        </Container>
      </div>
    </>
  );
};

export default PrivacyPolicy;
